import ENV from "config/Env";
import { typedQueryClient, usePermanentRealTimeUser, useTypedMutation } from "hooks";
import { LocationLicenseOverviewKeys } from "modules/LocationLicenseOverview/queryKeys";
import { ApiInstance } from "utils/Api";
import { getUserFullName } from "utils/common";
import { toISOString } from "utils/dateHelperFunctions";

type UpdateRemarkPayload = {
  remark: string;
  dealer_location_id?: number;
};

export const useUpdateRemarkMutation = () => {
  const { user } = usePermanentRealTimeUser();

  return useTypedMutation<UpdateRemarkPayload, void>({
    mutationFn: async payload => (await ApiInstance.post("/accounts/remark/update", payload, ENV.exactBaseURL)).data,
    onSuccess: ({ remark, dealer_location_id }) => {
      const filters = typedQueryClient.getQueryData(LocationLicenseOverviewKeys.filters);
      if (dealer_location_id !== filters?.location?.id) return;

      const currentRemark = typedQueryClient.getQueryData(LocationLicenseOverviewKeys.remark);
      if (!currentRemark) return;

      typedQueryClient.setQueryData(LocationLicenseOverviewKeys.remark, {
        exact_remark: remark,
        exact_remark_updated_on: toISOString(new Date()),
        exact_remark_updated_by: getUserFullName(user)
      });
    }
  });
};
